import CampaignManagement from "./campaign-management.page";

export default CampaignManagement;
